import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMedicalCaseComponent } from "./med-icon-medical-case.component";

@NgModule({
  declarations: [
    MedIconMedicalCaseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMedicalCaseComponent,
  ],
})
export class MedIconMedicalCaseModule { }
